"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Layout = _styledComponents["default"].div.withConfig({
  displayName: "PageLayout__Layout",
  componentId: "a0hns9-0"
})(["display:flex;flex-flow:row nowrap;height:100vh;overflow:hidden;"]);
/**
 *
 * #### Layout template component

Generally `PageLayout` would be your base wrapper container/component for your app. Its purpose is to provide a 2 column template that fills the current window/document. Under normal Blue Prism design guidelines, the left-hand side column would be primarily used for the `SideBar` container component leaving the right-hand side for your main content.

The component requires two container components to be passed into the provided props.

 */


var PageLayout = function PageLayout(_ref) {
  var sideContent = _ref.sideContent,
      mainContent = _ref.mainContent;
  return /*#__PURE__*/_react["default"].createElement(Layout, null, sideContent, mainContent);
};

var _default = PageLayout;
exports["default"] = _default;